package net.markdrew.biblebowl.web

fun main() {
    Shell.start()
}
